<div class="directory-settings-page">
  @if (configResource.isLoading()) {
    <zag-loading-state [message]="'common.loading' | translate" />
  } @else if (configResource.error()) {
    <zag-error-state [message]="'settings.directory.loadError' | translate" backLink="/settings" [backText]="'common.back' | translate" />
  } @else {
    <ng-template zagPageActions>
      <button zagButton type="button" [disabled]="isSaving() || settingsForm.invalid" (click)="onSave()">
        {{ 'common.save' | translate }}
      </button>
    </ng-template>

    <zag-entity-detail-layout>
      <div slot="sidebar">
        <zag-profile-summary-card [avatarName]="profileName()" avatarIcon="folder_shared" [subtitle]="profileSubtitle()" />
      </div>

      <form slot="content" [formGroup]="settingsForm">
        <zag-accordion>
          <!-- Microsoft Entra ID Section -->
          <zag-accordion-item [title]="'settings.directory.microsoft.title' | translate" icon="cloud_sync" [expanded]="true">
            <button
              slot="actions"
              type="button"
              class="directory-settings-page__help-btn"
              [zagTooltip]="'helpDialog.openTooltip.directoryMicrosoft' | translate"
              [attr.aria-label]="'helpDialog.openTooltip.directoryMicrosoft' | translate"
              (click)="openMicrosoftHelp()"
            >
              <span zagIcon="help-outline"></span>
            </button>
            <div class="directory-settings-page__section">
              <zag-form-field [label]="'settings.directory.microsoft.enabled' | translate">
                <zag-checkbox formControlName="microsoftEnabled" [label]="'settings.directory.microsoft.enabled' | translate" />
              </zag-form-field>

              @if (settingsForm.get('microsoftEnabled')?.value) {
                <zag-form-field [label]="'settings.directory.microsoft.tenantId' | translate">
                  <zag-input formControlName="microsoftTenantId" placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx" />
                </zag-form-field>
                <zag-form-field [label]="'settings.directory.microsoft.clientId' | translate">
                  <zag-input formControlName="microsoftClientId" placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx" />
                </zag-form-field>
                <zag-form-field [label]="'settings.directory.microsoft.clientSecret' | translate">
                  <zag-input formControlName="microsoftClientSecret" type="password" [placeholder]="secretPlaceholder()" />
                </zag-form-field>

                <div class="directory-settings-page__permissions-info">
                  <strong>{{ 'settings.directory.microsoft.permissions' | translate }}</strong>
                  <ul>
                    <li>{{ 'settings.directory.microsoft.permissionsList' | translate }}</li>
                  </ul>
                </div>

                @if (testResult()) {
                  <div
                    class="directory-settings-page__test-result"
                    [class.directory-settings-page__test-result--success]="testResult()?.success"
                    [class.directory-settings-page__test-result--error]="!testResult()?.success"
                    role="status"
                  >
                    {{ testResult()?.message }}
                  </div>
                }

                <div class="directory-settings-page__test-action">
                  <button
                    zagButton="outlined"
                    type="button"
                    (click)="onTestConnection()"
                    [disabled]="isTesting()"
                    [zagLoading]="isTesting()"
                  >
                    {{ 'settings.directory.test.button' | translate }}
                  </button>
                </div>
              }
            </div>
          </zag-accordion-item>

          <!-- Google Workspace Section (Coming Soon) -->
          <zag-accordion-item [title]="'settings.directory.google.title' | translate" icon="corporate_fare" [expanded]="false">
            <button
              slot="actions"
              type="button"
              class="directory-settings-page__help-btn"
              [zagTooltip]="'helpDialog.openTooltip.directoryGoogle' | translate"
              [attr.aria-label]="'helpDialog.openTooltip.directoryGoogle' | translate"
              (click)="openGoogleHelp()"
            >
              <span zagIcon="help-outline"></span>
            </button>
            <div class="directory-settings-page__section directory-settings-page__section--disabled">
              <p class="directory-settings-page__coming-soon">
                {{ 'settings.directory.google.comingSoon' | translate }}
              </p>
            </div>
          </zag-accordion-item>
        </zag-accordion>
      </form>
    </zag-entity-detail-layout>
  }
</div>
